import { Button, Container } from 'components/atoms';
import { useFormikContext } from 'formik';
import { t } from 'i18next';

import { IFormikContextType } from 'hooks/useFormikField';
import { ITrackMutationForm } from 'services/tracks/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { usePostMusicProductDigitalFromTrack } from 'services/tracks';

const TrackProduct = () => {
  const { values }: IFormikContextType<ITrackMutationForm> = useFormikContext<ITrackMutationForm>();

  const createFromTrack = usePostMusicProductDigitalFromTrack();

  const handleAddProduct = async () => {
    if (!values?.id) return;

    const mpdId = await createFromTrack.mutateAsync({
      trackId: values.id,
    });
  };

  return (
    <Container>
      <Container.Header title={t('input.label.products')} />

      <Button
        fullWidth
        variant={BUTTON_VARIANT.submit}
        isLoading={createFromTrack.isPending}
        onClick={handleAddProduct}
        disabled={!values?.id}
      >
        {t('input.label.addProduct')}
      </Button>
    </Container>
  );
};

export default TrackProduct;
